import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet-async";
import Footer from "../layouts/footer/Footer";
import ShopMain from "../layouts/main/ShopMain";
import PRODUCT_CHUNK, { DEFAULT_LANGUAGE } from "../utils/global_const";
import { useParams } from "react-router-dom";
import { ProductContext } from "../context/ProductContext";
import Header from "../layouts/header/Header";
import brandDescriptions from "../brand_descriptions.json";

const SEOConfig = {
  en: {
    title: "Shop | SnusCo",
    description:
      "Explore our wide range of nicotine pouches and find your perfect match at SnusCo. Shop now and enjoy premium quality and variety.",
    keywords:
      "nicotine pouches, snus, buy snus online, best nicotine pouches, SnusCo shop",
    url: "https://www.snusco.at/en/snus-verkauf",
    images: [
      "https://www.snusco.at/assets/default-category-image.jpg",
    ],
  },
  de: {
    title: "Shop | SnusCo",
    description:
      "Willkommen bei SnusCo – Ihrem Fachgeschäft für hochwertige nikotinfreie und nikotinhaltige Beutel. Entdecken Sie unser breites Sortiment an Geschmacksrichtungen und Stärken. Jetzt bestellen und den besten Snus genießen!",
    keywords:
      "Nikotinbeutel, SnusCo, Snus kaufen, Nikotin Pouches, hochwertiger Snus",
    url: "https://www.snusco.at/de/snus-verkauf",
    images: [
      "https://www.snusco.at/assets/default-category-image.jpg",
    ],
  },
};
const Shop = () => {
  const { i18n } = useTranslation();
  const { slug } = useParams();
  const [seo, setSeo] = useState(SEOConfig[DEFAULT_LANGUAGE]);
  const { loadProducts, loadProductsByCategorySlug, setCategory, category } =
    useContext(ProductContext);

  useEffect(() => {
    // Odredi jezik
    const lang = i18n.language === "de" ? "de" : "en";
    const defaultSEO = SEOConfig[lang] || SEOConfig[DEFAULT_LANGUAGE];

    // Pokušaj da nadješ brend po slug-u (samo za SEO opis, ne odlucuje da li se filtrira)
    const entry = brandDescriptions.find((item) => item.slug === slug);

    if (entry) {
      const descKey = lang === "de" ? "short_de" : "short_en";
      const seoDescription = entry[descKey] || defaultSEO.description;
      const seoTitle = `${entry.brand_name} | SnusCo Europe`;
      const categoryUrl = `https://www.snusco.at/${lang}/snus-verkauf/${slug}`;

      setSeo({
        title: seoTitle,
        description: seoDescription,
        keywords: `${entry.brand_name}, ${defaultSEO.keywords}`,
        url: categoryUrl,
        images: defaultSEO.images,
      });
    } else {
      setSeo(defaultSEO);
    }

    if (slug) {
      loadProductsByCategorySlug(slug);
    } else {
      loadProducts();
      setCategory(null);
    }
  }, [slug, i18n.language]);

  return (
    <div>
      <Helmet>
        <html lang={i18n.language} />
        <title>{seo.title}</title>
        <meta name="description" content={seo.description} />
        <meta name="keywords" content={seo.keywords} />
        <meta name="robots" content="index, follow" />
        <meta property="og:title" content={seo.title} />
        <meta property="og:description" content={seo.description} />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={seo.url} />

        {/* Open Graph slike - Primarna slika na prvom mestu */}
        {seo.images?.map((image, index) => (
          <meta key={index} property="og:image" content={image} />
        ))}

        <meta charset="UTF-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <meta name="author" content="SnusCo" />
        <link rel="canonical" href={seo.url} />
      </Helmet>
      <Header />
      <ShopMain />
      <Footer />
    </div>
  );
};

export default Shop;
